
import { UserInfo } from '../models/user-info.model';
import { Injectable } from '@angular/core';

// Backs auth state with sessionStorage so a page refresh doesn't wipe the login session (this service is otherwise purely in-memory)
const STORAGE_KEY = 'ermsurvey.session';

interface PersistedSession {
  user: any;
  isAdmin: boolean;
  isAuthenticated: boolean;
  token: string;
  roles: string[];
  permissions: string[];
}

@Injectable()
export class Globals {
  public LoggedInUser: UserInfo;

  private _user: any;
  private _isAdmin: boolean;
  private _isAuthenticated: boolean;
  private _token: string;
  private _roles: string[];
  private _permissions: string[];

  constructor() {
    const persisted = this.readSession();
    this._user = persisted?.user ?? null;
    this._isAdmin = persisted?.isAdmin ?? false;
    this._isAuthenticated = persisted?.isAuthenticated ?? false;
    this._token = persisted?.token ?? null;
    this._roles = persisted?.roles ?? null;
    this._permissions = persisted?.permissions ?? null;
  }

  public get user(): any { return this._user; }
  public set user(value: any) { this._user = value; this.writeSession(); }

  public get isAdmin(): boolean { return this._isAdmin; }
  public set isAdmin(value: boolean) { this._isAdmin = value; this.writeSession(); }

  public get isAuthenticated(): boolean { return this._isAuthenticated; }
  public set isAuthenticated(value: boolean) { this._isAuthenticated = value; this.writeSession(); }

  public get token(): string { return this._token; }
  public set token(value: string) { this._token = value; this.writeSession(); }

  public get roles(): string[] { return this._roles; }
  public set roles(value: string[]) { this._roles = value; this.writeSession(); }

  public get permissions(): string[] { return this._permissions; }
  public set permissions(value: string[]) { this._permissions = value; this.writeSession(); }

  private readSession(): PersistedSession | null {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }

  private writeSession(): void {
    if (!this._isAuthenticated) {
      sessionStorage.removeItem(STORAGE_KEY);
      return;
    }
    const session: PersistedSession = {
      user: this._user,
      isAdmin: this._isAdmin,
      isAuthenticated: this._isAuthenticated,
      token: this._token,
      roles: this._roles,
      permissions: this._permissions
    };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session));
  }
}

